import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import paint1 from "../assets/paint1.png";
import paint2 from "../assets/paint2.png";
import paint3 from "../assets/paint3.png";
import paint4 from "../assets/paint4.png";
import paint5 from "../assets/paint5.png";
import paint6 from "../assets/paint6.png";
import paint7 from "../assets/paint7.png";
import paint8 from "../assets/paint8.png";
import "./ProductDetail.css";
import { getCartUserId } from "../utils/cartUser";
import { addItemToLocalCart } from "../utils/localCart";

// ✅ Product list
const allProducts = [
  {
    id: 1,
    name: "Plastic Emulsion",
    img: paint1,
    reviewCount: 187,
    desc: "Durable, smooth finish for interior walls with long-lasting color.",
  },
  {
    id: 2,
    name: "High Class Emulsion",
    img: paint6,
    reviewCount: 96,
    desc: "Premium emulsion offering elegant matte finish for modern interiors.",
  },
  {
    id: 3,
    name: "Wall Putty",
    img: paint2,
    reviewCount: 243,
    desc: "Gives walls a smooth base, improving paint finish and durability.",
  },
  {
    id: 4,
    name: "Gloss Enamel",
    img: paint7,
    reviewCount: 121,
    desc: "Shiny, weather-resistant finish for wood and metal surfaces.",
  },
  {
    id: 5,
    name: "Aquatic Matt Emulsion",
    img: paint3,
    reviewCount: 74,
    desc: "Soft matte finish, moisture-resistant for elegant interior walls.",
  },
  {
    id: 6,
    name: "Weather Guard",
    img: paint4,
    reviewCount: 158,
    desc: "Strong weather protection with anti-peel technology for exteriors.",
  },
  {
    id: 7,
    name: "Aquatic Wall Sealer",
    img: paint5,
    reviewCount: 209,
    desc: "Improves paint adhesion and prevents dampness on walls.",
  },
  {
    id: 8,
    name: "Glamur Acrylic",
    img: paint8,
    reviewCount: 52,
    desc: "Higher quality acrylic with excellent bonding for exterior applications.",
  },
];

const colorPalettes = {
  "Plastic Emulsion": {
    normal: [
      { name: "Off White 1", hex: "#Fef9Db" },
      { name: "Lilly White 144", hex: "#Fefefc" },
      { name: "Cream 18", hex: "#Fde9A4" },
      { name: "Dry Wheat 145", hex: "#Cdb18C" },
      { name: "Honey Dew 38", hex: "#E2B691" },
      { name: "Ash White 103", hex: "#E6E6E6" },
      { name: "Ash Grey New 003", hex: "#D1D6Da" },
      { name: "Silver Mist New 004", hex: "#Adb8Be" },
      { name: "Cockle Shell 33", hex: "#E2Ded2" },
      { name: "Cameo 146", hex: "#E4C19B" },
      { name: "Ice Berg 148", hex: "#E6F9F3" },
      { name: "Star Dust 41", hex: "#C0Ddd9" },
      { name: "Lagoon Blue 6", hex: "#66C1D3" },
      { name: "Crystal Green 8", hex: "#8Bc1A9" },
      { name: "Flora Green 25", hex: "#Bfdf94" },
      { name: "Rose White 34", hex: "#Fef4Db" },
      { name: "Peach Cream 32", hex: "#94B6BB" },
      { name: "H-Pink 26", hex: "#Fbd2Cc" },
      { name: "Sea Blue 37", hex: "#D0F2Fb" },
      { name: "Heaven Blue", hex: "#6Acaf0" },
      { name: "Arabian Blue 7", hex: "#1Bade9" },
      { name: "Salmon 141", hex: "#Fdc997" },
      { name: "Orange 16", hex: "#Faa76E" },
      { name: "Terracotta 147", hex: "#B8816D" },
      { name: "Sand Stone  133", hex: "#D0Bbaa" },
      { name: "Deep Rose 22", hex: "#D1Bbad" },
      { name: "Spice 42", hex: "#7E6A61" },
      { name: "Permanent Green 12", hex: "#4Fc2Bf" },
      { name: "Valley Green 10", hex: "#A7D0A4" },
      { name: "Leaf Green 143", hex: "#7A8364" },
      { name: "Orchard Lane 142", hex: "#C9C0Dd" },
      { name: "Violet 15", hex: "#8Ea9D6" },
      { name: "Torres Blue", hex: "#C0Dff4" },
    ],
    special: [
      { name: "Mango Yellow 134", hex: "#Fbce59" },
      { name: "Fresh Orange 136", hex: "#F4825D" },
      { name: "Spring Green 137", hex: "#A8Bf57" },
      { name: "Jade 150", hex: "#406A69" },
      { name: "Carnival Pink 149", hex: "#D06A8F" },
      { name: "Tile Red", hex: "#A64346" },
      { name: "Velvet 135", hex: "#6391C3" },
      { name: "H-Blue 138", hex: "#196Ea7" },
      { name: "Black 151", hex: "#2B2F32" },
    ],
  },
  "High Class Emulsion": {
    // normal: [
    //   { name: "Paraffin", hex: "#F1F1E3" },
    //   { name: "Metallics & Textures", hex: "#BB8487" },
    //   { name: "Fresh Green", hex: "#CED37D" },
    //   { name: "Classical", hex: "#D0CBDE" },
    //   { name: "Peach Cream", hex: "#D8A48F" },
    //   { name: "Pink", hex: "#FFE3ED" },
    //   { name: "Cool & Calm", hex: "#94B6BB" },
    // ],
    special: [
      // { name: "Cockle Shell 33", hex: "#5c55c0ff" },
    ],
  },
  "Wall Putty": {
    normal: [
      // { name: "Turquoise", hex: "#A3A37F" },
      // { name: "Choclate", hex: "#866D5D" },
      // { name: "Pastel Green", hex: "#CED1AD" },
      // { name: "Bold & Bright", hex: "#BF7C29" },
      // { name: "Hush Rose", hex: "#FDEDE0" },
      // { name: "Warm & Earthy", hex: "#D7CE93" },
      // { name: "Goose Wing", hex: "#A8ABA3" },
    ],
    special: [
      // { name: "Cockle Shell 33", hex: "#4fc0afff" },
    ],
  },
  "Gloss Enamel": {
    normal: [
      { name: "Sweet William 609", hex: "#F2A8B7" },
      { name: "Sea Green 615", hex: "#6Ac4Aa" },
      { name: "Sky Blue 621", hex: "#27B8Ed" },
      { name: "Mauve 610", hex: "#Aeadcc" },
      { name: "Adam Green 616", hex: "#32A59E" },
      { name: "Vivid Blue 622", hex: "#014B92" },
      { name: "Off White 601", hex: "#Ffffff" },
      { name: "Cameo 605", hex: "#Efb58D" },
      { name: "State Grey 611", hex: "#Aaaeaf" },
      { name: "Signal Green 617", hex: "#0E4235" },
      { name: "Light Blue 623", hex: "#0389C6" },
      { name: "Ash White 602", hex: "#E4E0D7" },
      { name: "Orange 606", hex: "#D33404" },
      { name: "Light Grey 612", hex: "#858F90" },
      { name: "Sring Green 618", hex: "#4B8A28" },
      { name: "Golden Brown 624", hex: "#893B0D" },
      { name: "Brown 625", hex: "#78340D" },
      { name: "Leather Brown 626", hex: "#33221B" },
      { name: "Beige 603", hex: "#D7B18D" },
      { name: "Signal Red 607", hex: "#9D020A" },
      { name: "Royal Green 619", hex: "#0E3729" },
      { name: "Golden Yellow 604", hex: "#Fcc300" },
      { name: "Red Oxide 608", hex: "#5B1C15" },
      { name: "Dark Grey 614", hex: "#F7F7F6" },
      { name: "Royal Blue 620", hex: "#0C1A35" },
    ],
    special: [
      // { name: "Cockle Shell 33", hex: "#14c558ff" },
    ],
  },
  "Aquatic Matt Emulsion": {
    // normal: [
    //   { name: "Pastel Green", hex: "#CED1AD" },
    //   { name: "Classical", hex: "#D0CBDE" },
    //   { name: "Carnival Pink", hex: "#C981B2" },
    //   { name: "Light Blue", hex: "#BAEBF4" },
    //   { name: "Buttercup Bouquet", hex: "#FFED9A" },
    //   { name: "Goose Wing", hex: "#A8ABA3" },
    //   { name: "Hush Rose", hex: "#FDEDE0" },
    // ],
    special: [
      // { name: "Cockle Shell 33", hex: "#e3bf56ff" },
    ],
  },
  "Weather Guard": {
    // normal: [
    //   { name: "Carnival Pink", hex: "#C10FB7" },
    //   { name: "Pastel Green", hex: "#CED1AD" },
    //   { name: "Light Blue", hex: "#BAEBF4" },
    //   { name: "Melody Green", hex: "#CAF2D0" },
    //   { name: "Fresh Green", hex: "#CED37D" },
    //   { name: "Pink", hex: "#FFE3ED" },
    //   { name: "Classical", hex: "#D0CBDE" },
    // ],
    special: [
      // { name: "Cockle Shell 33", hex: "#2d7ac8ff" },
    ],
  },
  "Aquatic Wall Sealer": {
    normal: [
      // { name: "Neutrals & Pastels", hex: "#EBB78F" },
      // { name: "Carnival Pink", hex: "#C981B2" },
      // { name: "Rose White", hex: "#E3DC8E" },
      // { name: "Grey Dew", hex: "#DFEAEC" },
      // { name: "Gold Mist", hex: "#B4AC3D" },
      // { name: "Buttercup Bouquet", hex: "#FFED9A" },
      // { name: "Choclate", hex: "#866D5D" },
    ],
    special: [
      // { name: "Cockle Shell 33", hex: "#ea2facff" },
    ],
  },
  "Glamur Acrylic": {
    normal: [],
    special: [],
  },
};

// ✅ Product-specific pricing (easy to adjust in future)
const categoryPrices = {
  "Plastic Emulsion": {
    normal: { Quarter: 290, Gallon: 1145, Drum: 4030 },
    special: { Quarter: 325, Gallon: 1245 },
  },
  "High Class Emulsion": {
    normal: { Quarter: 0, Gallon: 0, Drum: 0 },
    // special: {Quarter: 265, Gallon: 965, Drum: 3575 },
  },
  "Wall Putty": {
    normal: { Quarter: 260, Gallon: 975, Drum: 3630 },
    // special: { Quarter: 220, Gallon: 820, Drum: 3050 },
  },
  "Gloss Enamel": {
    normal: { Quarter: 985, Gallon: 3900},
    // special: { Quarter: 265, Gallon: 965, Drum: 3575 },
  },
  "Aquatic Matt Emulsion": {
    normal: { Quarter: 0, Gallon: 0, Drum: 0 },
    // special: { Quarter: 265, Gallon: 965, Drum: 3575 },
  },
  "Weather Guard": {
    normal: { Quarter: 0, Gallon: 0, Drum: 0 },
    // special: {Quarter: 265, Gallon: 965, Drum: 3575 },
  },
  "Aquatic Wall Sealer": {
    normal: { Quarter: 400, Gallon: 1465, Drum: 5265 },
    // special: { Quarter: 370, Gallon: 1350, Drum: 4985 },
  },
  "Glamur Acrylic": {
    normal: { "0.5 kg": 175, "1 kg": 350 },
  },
};

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const productData = allProducts.find((p) => p.id === Number(id));
  const [selectedShade, setSelectedShade] = useState(null);
  const [selectedSize, setSelectedSize] = useState("Quarter");
  const [quantity, setQuantity] = useState(1);
  const [finalPrice, setFinalPrice] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const [popup, setPopup] = useState({
    show: false,
    msg: "",
    showGoCart: false,
  });

  const normalColors = colorPalettes[productData?.name]?.normal || [];
  const specialColors = colorPalettes[productData?.name]?.special || [];

  // const isSpecialShade =
  //   productData?.name === "Plastic Emulsion" &&
  //   specialColors.some((c) => c.hex === selectedShade?.hex);
 const isSpecialShade =
  ["Plastic Emulsion", "High Class Emulsion"].includes(productData?.name) &&
  selectedShade &&
  specialColors.some((c) => c.hex === selectedShade.hex);

   useEffect(() => {
  // Reset selections when switching to a new product
  setSelectedShade(null);
  setSelectedSize(Object.keys(categoryPrices[productData?.name]?.normal || {})[0] || "Quarter");
  setQuantity(1);
  setFinalPrice(0);
  // window.scrollTo(0, 0); 
}, [id, productData?.name]); 

  // ✅ Fetch cart count
  useEffect(() => {
    const userId = getCartUserId();
    fetch(`https://gp-live-backend.vercel.app/api/cart/${userId}`)
      .then((res) => res.json())
      .then((data) => setCartCount(data.length))
      .catch(() => {});
  }, []);

  // ✅ Update price whenever selection changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
 useEffect(() => {
  if (!productData || !selectedSize) return;

  const cat = productData.name;
  const isSpecial =
    selectedShade && specialColors.some((s) => s.name === selectedShade.name);

  const priceSet = isSpecial
    ? categoryPrices[cat]?.special
    : categoryPrices[cat]?.normal;

  setFinalPrice(priceSet?.[selectedSize] || 0);
}, );

  if (!productData) return <p>Product not found.</p>;

  const showPopupMessage = (msg, showGoCart = false) => {
    setPopup({ show: true, msg, showGoCart });
    setTimeout(
      () => setPopup({ show: false, msg: "", showGoCart: false }),
      2200
    );
  };

  const hasShadeOptions = normalColors.length > 0 || specialColors.length > 0;

  const handleAddToCart = async () => {
    if (finalPrice <= 0) {
      showPopupMessage("This product will be live soon");
      return;
    }

    if (hasShadeOptions && !selectedShade) {
      showPopupMessage("Please select color shade.");
      return;
    }

    const userId = getCartUserId();
    const cartItemPayload = {
      userId,
      name: productData.name,
      price: finalPrice,
      img: productData.img,
      quantity,
      size: selectedSize,
      color: {
        name: selectedShade?.name || "N/A",
        hex: selectedShade?.hex || "#000",
      },
    };

    const addToLocalFallback = () => {
      const localItems = addItemToLocalCart(userId, cartItemPayload);
      setCartCount(localItems.length);
      showPopupMessage(`${productData.name} added to cart!`, true);
      window.dispatchEvent(new Event("cartUpdated"));
    };

    try {
      const res = await fetch("https://gp-live-backend.vercel.app/api/cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cartItemPayload),
      });
      if (!res.ok) {
        addToLocalFallback();
        return;
      }

      setCartCount((prev) => prev + 1);
      showPopupMessage(`${productData.name} added to cart!`, true);
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error(err);
      addToLocalFallback();
    }
  };

  const currentBucketOptions = isSpecialShade
    ? Object.keys(categoryPrices[productData.name].special)
    : Object.keys(categoryPrices[productData.name].normal);

  return (
    <div className="product-page">
      <aside className="sidebar">
        <h3>Products</h3>
        <ul>
          {allProducts.map((p) => (
            <li
              key={p.id}
              className={`sidebar-product ${
                p.id === productData.id ? "active" : ""
              }`}
              onClick={() => navigate(`/products/${p.id}`)}
            >
              <input type="radio" checked={p.id === productData.id} readOnly />
              <span>{p.name}</span>
            </li>
          ))}
        </ul>
      </aside>

      <section className="productdetail">
        <div className="breadcrumb">
          E-Store &gt; Our Product &gt; <span>{productData.name}</span>
        </div>

        <div className="productdetail-container">
          <div className="productdetail-image">
            <img src={productData.img} alt={productData.name} />
          </div>

          <div className="productdetail-info">
            <h2>{productData.name}</h2>
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} className="star" />
              ))}
              <span>({productData.reviewCount ?? 0})</span>
            </div>

            <h4 className="price">Rs {finalPrice * quantity}</h4>
            <p className="desc">{productData.desc}</p>

            {normalColors.length > 0 && (
              <div className="color-selector">
                <h5>Normal Shades</h5>
                <div className="color-palette">
                  {normalColors.map((color, i) => (
                    <div
                      key={i}
                      className={`color-box ${
                        selectedShade?.hex === color.hex ? "active" : ""
                      }`}
                      style={{ background: color.hex }}
                      onClick={() => setSelectedShade(color)}
                      // title={`${color.name} (${color.hex})`}
                      title={`${color.name} `}
                    />
                  ))}
                </div>
              </div>
            )}

            {specialColors.length > 0 && (
              <div className="color-selector ">
                <h5>Special Shades</h5>
                <div className="color-palette">
                  {specialColors.map((color, i) => (
                    <div
                      key={i}
                      className={`color-box  ${
                        selectedShade?.hex === color.hex ? "active" : ""
                      }`}
                      style={{ background: color.hex }}
                      onClick={() => {
                        setSelectedShade(color);
                        setSelectedSize("Quarter");
                      }}
                      // title={`${color.name} (${color.hex})`}
                      title={`${color.name} `}
                    />
                  ))}
                </div>
              </div>
            )}

            {selectedShade && (
              <p className="selected-color-name">
                {/* <strong>{selectedShade.name}</strong> {selectedShade.hex} */}
                 <strong>{selectedShade.name}</strong> 
              </p>
            )}

            <div className="size-selector">
              <h5>Select Bucket Size</h5>
              <div className="size-options">
                {currentBucketOptions.map((size) => (
                  <button
                    key={size}
                    className={`size-btn ${
                      selectedSize === size ? "active" : ""
                    }`}
                    onClick={() => setSelectedSize(size)}
                  >
                    {size}
                  </button>
                ))}
                {isSpecialShade &&
                  !categoryPrices[productData.name].special.Drum && (
                    <button className="size-btn disabled" disabled>
                      Drum (Not available)
                    </button>
                  )}
              </div>
            </div>

            <div className="quantity-controls-inline">
              <h5>Quantity</h5>
              <div className="quantity-inline">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>
                  -
                </button>
                <span>{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)}>+</button>
              </div>
            </div>

            <button className="add-to-cart" onClick={handleAddToCart}>
              Add To Cart
            </button>
            <button onClick={() => navigate("/cart")} className="add-to-cart1">
              View Cart 🛒 <span>{cartCount}</span>
            </button>
          </div>
        </div>

        {popup.show && (
          <div className="popup-overlay">
            <div className="popup-box">
              <p>{popup.msg}</p>
              {popup.showGoCart && (
                <button
                  onClick={() => navigate("/cart")}
                  className="go-cart-btn"
                >
                  Go to Cart
                </button>
              )}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
